import React from 'react'

import AboutCTR from '../containers/about/AboutCTR'

function About() {
    return (
        <>
            <AboutCTR />
        </>
    )
}

export default About
